// constrain "@keystar/ui" to "@keystar/primitives", without publishing
const TOKEN_PREFIX = 'kui';
const THEME_DEFAULT = `${TOKEN_PREFIX}-theme`;
const SCHEME_AUTO = `${TOKEN_PREFIX}-scheme--auto`;
const SCHEME_LIGHT = `${TOKEN_PREFIX}-scheme--light`;
const SCHEME_DARK = `${TOKEN_PREFIX}-scheme--dark`;

export { SCHEME_AUTO, SCHEME_DARK, SCHEME_LIGHT, THEME_DEFAULT, TOKEN_PREFIX };
